import alt from "../alt";
import indexBy from "lodash/keyBy";
import values from "lodash/values";
import NoteUtil from "../utils/NoteUtil";
import NoteActions from "../actions/NoteActions";
import UserStore from "../stores/UserStore";

class NoteStore {
  constructor() {
    this.bindActions(NoteActions);

    this.state = {
      notes: {},
      isFetching: false,
      isEditing: null
    };

    this.exportPublicMethods({
      getNoteById: this.getNoteById.bind(this),
      getNotesForPerson: this.getNotesForPerson.bind(this),
      getNotesForOrder: this.getNotesForOrder.bind(this)
    });
  }

  getNoteById(id) {
    return this.state.notes[id];
  }

  getNotesForPerson(id) {
    return values(this.state.notes).filter(function(n) {
      return n.person === id;
    });
  }

  getNotesForOrder(id) {
    return values(this.state.notes).filter(function(n) {
      return n.order === id;
    });
  }

  onFetchAllForPerson(person) {
    this.setState({ isFetching: true });
    NoteUtil.fetchAllForPerson(UserStore.getState().apiKey, person)
      .then(data => {
        NoteActions.updateNotes(indexBy(data, "id"));
        this.setState({ isFetching: false });
      })
      .catch(NoteActions.fetchFailed);
  }

  onFetchAllForOrder(order) {
    this.setState({ isFetching: true });
    NoteUtil.fetchAllForOrder(UserStore.getState().apiKey, order)
      .then(data => {
        NoteActions.updateNotes(indexBy(data, "id"));
        this.setState({ isFetching: false });
      })
      .catch(NoteActions.fetchFailed);
  }

  onFetchOne(id) {
    NoteUtil.fetchOne(UserStore.getState().apiKey, id)
      .then(data => {
        NoteActions.updateNote(id, data);
      })
      .catch(NoteActions.fetchFailed);
  }

  onEdit(newData) {
    this.setState({ isEditing: newData.id });
    NoteUtil.edit(UserStore.getState().apiKey, newData.id, newData.values)
      .then(data => {
        window.Intercom("trackEvent", "edit-note");

        NoteActions.updateNote(newData.id, data);
        this.setState({ isEditing: null });
      })
      .catch(NoteActions.editFailed);
  }

  onDelete(id) {
    NoteUtil.delete(UserStore.getState().apiKey, id)
      .then(data => {
        NoteActions.updateNote(id, undefined);
      })
      .catch(NoteActions.editFailed);
  }

  onCreate(newData) {
    this.setState({ isCreating: true });

    NoteUtil.create(UserStore.getState().apiKey, newData)
      .then(data => {
        NoteActions.updateNote(data.id, data);
        this.setState({ isCreating: false });
      })
      .catch(NoteActions.editFailed);
  }

  onUpdateNotes(notes) {
    this.setState({ notes });
  }

  onUpdateNote(data) {
    if (!data.note) {
      delete this.state.notes[data.id];
    } else {
      this.state.notes[data.id] = data.note;
    }
    this.state.newNoteId = null;
    this.setState(this.state);
  }

  onFetchFailed(e) {
    alert(`Fetching notes failed: ${e.message}`);
    throw e;
  }

  onEditFailed(e) {
    alert(`Edit failed: ${e.message}`);
    this.setState({ isCreating: false, isEditing: false });
  }
}

export default alt.createStore(NoteStore, "NoteStore");



// WEBPACK FOOTER //
// ./src/app/stores/NoteStore.js